import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { QuartzJobService } from '../quartz-job.service';
import { QuartzJob } from '../quartz-job';
import * as moment from 'moment';


@Component({
    selector: 'app-quartz-job-list',
    templateUrl: './quartz-job-list.component.html',
    styleUrls: ['./quartz-job-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class QuartzJobListComponent implements OnInit {
	constructor(
		private quartzJobService: QuartzJobService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = quartzJobService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	quartzJobs: any;
	quartzJob: QuartzJob;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'quartzJobId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'state', header: 'State', width: 'auto' },
		{ field: 'prevFireTime', header: 'Prev. Fire Time', width: 'auto' },
		{ field: 'nextFireTime', header: 'Next Fire Time', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.quartzJobId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				//this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-quartzJob-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.quartzJobService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.quartzJobs = res.data.quartzJobs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.quartzJobs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(quartzJob: QuartzJob) {
		try {
			this.formLoading = true;
			this.quartzJobService.update(quartzJob)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.quartzJobs.map((quartzJob, i) => {
							if (quartzJob.quartzJobId === res.data.quartzJob.quartzJobId) {
								this.quartzJobs[i] = res.data.quartzJob;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 *
	formDelete(quartzJob: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(quartzJob));

			this.formLoading = true;
			this.quartzJobService.delete(quartzJob.quartzJobId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.quartzJobs.splice(this.quartzJobs.indexOf(quartzJob), 1);
						this.recordTotal = this.quartzJobs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'QuartzJob ' + quartzJob.quartzJobId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'QuartzJob ' + quartzJob.quartzJobId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		/*const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add QuartzJob'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(QuartzJobComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addQuartzJobCB(data);

				// close the dialogBox
				dialogRef.close();
			});*/
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(quartzJob: QuartzJob) {

		/*const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			quartzJob: quartzJob,
			title: 'Edit QuartzJob'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(QuartzJobComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateQuartzJobCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteQuartzJobCB(data);

				// close the dialogBox
				dialogRef.close();
			});*/
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addQuartzJobCB(quartzJob: QuartzJob) {
		console.log('Adding QuartzJob: ' + JSON.stringify(quartzJob));
		// if we don't have a quartzJobs array yet...
		if (!this.quartzJobs) {
			this.quartzJobs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.quartzJobs.unshift(quartzJob);

		// no idea what this is but it is required to update the array
		this.quartzJobs = [...this.quartzJobs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'QuartzJob ' + quartzJob.quartzJobId + ' Added', life: 3000 });
	}

	triggerNow(quartzJob: QuartzJob) {
		try{




			console.log('ontriggerNow: ' + JSON.stringify(quartzJob));
				this.confirmationService.confirm({
					message: 'Are you sure you want to trigger ' + quartzJob.name + '?',
					header: 'Confirm',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						//this.formDelete(event);

						this.quartzJobService.triggerNow(quartzJob.name)
						.subscribe(
							(res: any) => {
								console.log('quartzJob triggerNow SUCCESS: ' + JSON.stringify(res));
								// this.alertService.success(res, true);
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							},
							(err: any) => {
								console.log('quartzJob triggerNow FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
							},
							() => { this.formLoading = false; });
					},
					reject: () => {
						this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
					}
				});

		
		}catch(e){

		}
	}

	resetTriggerState(quartzJob: QuartzJob) {
		try{
			this.quartzJobService.resetTriggerState(quartzJob.name)
			.subscribe(
				(res: any) => {
					console.log('quartzJob resetTriggerState SUCCESS: ' + JSON.stringify(res));
					// this.alertService.success(res, true);
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
				},
				(err: any) => {
					console.log('quartzJob resetTriggerState FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
				},
				() => { this.formLoading = false; });
		}catch(e){

		}
	
	}

	updateQuartzJobCB(quartzJob: QuartzJob) {
		console.log('Updating QuartzJob: ' + JSON.stringify(quartzJob));
		let itemIndex = this.quartzJobs.findIndex((item: any) => item.quartzJobId === quartzJob.quartzJobId);
		this.quartzJobs[itemIndex] = quartzJob;

		// no idea what this is but it is required to update the array
		this.quartzJobs = [...this.quartzJobs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'QuartzJob ' + quartzJob.quartzJobId + ' Updated', life: 3000 });
	}

	deleteQuartzJobCB(quartzJob: QuartzJob) {
		console.log('Removing QuartzJob: ' + quartzJob);
		this.quartzJobs.splice(this.quartzJobs.indexOf(quartzJob), 1);
		this.recordTotal = this.quartzJobs.length;

		// no idea what this is but it is required to update the array
		this.quartzJobs = [...this.quartzJobs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'QuartzJob ' + quartzJob.quartzJobId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.quartzJobs ? this.first === (this.quartzJobs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.quartzJobs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(quartzJob: any) {
		if (quartzJob?.status) {
			const status = this.statuses.find((e: any) => e.value == quartzJob.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}

	
	fixDateTime(date: any) {
		// create date objects - why can't primeng do this?
		return moment(date).format('MM/DD/YYYY HH:mm:ss');
	}
}
